export default {
  instructions: `
    Play the video to learn how to use My Move. Or click the <b>Continue</b> button
    to skip these instructions.
  `,
};
